import { useApiGet } from '@sierralabs/core-ui';
export function useFindSites() {
    const { data, isLoading, error, get } = useApiGet('sites');
    return {
        sites: data,
        loadingSites: isLoading,
        loadingSitesError: error,
        findSites: get
    };
}
//# sourceMappingURL=useFindSites.js.map